/**
 * Sally活动弹窗控制器
 * 用于在发布操作中拦截Sally活动话题，提示用户前往小程序
 */
import { reactive } from 'vue'
import { useGlobalConfigStore } from '@/stores/globalConfig'

interface SallyActivityDialogState {
  visible: boolean
}

const state = reactive<SallyActivityDialogState>({
  visible: false
})

export function useSallyActivityDialog() {
  const showSallyActivityDialog = () => {
    state.visible = true
  }

  const hideSallyActivityDialog = () => {
    state.visible = false
  }

  /**
   * 判断指定 topicId 是否为 Sally 活动
   */
  const isSallyTopic = (topicId?: string): boolean => {
    if (!topicId) return false
    const globalConfigStore = useGlobalConfigStore()
    const sallyActivity = globalConfigStore.feSettings?.sallyActivity
    return !!sallyActivity?.uniqueTopicId && topicId === sallyActivity.uniqueTopicId
  }

  return {
    state,
    showSallyActivityDialog,
    hideSallyActivityDialog,
    isSallyTopic
  }
}
